<template>
  <div class="chat" @click.stop="hideDialog">
    <div class="chat-main">

    <!--水印-->
    <!--    <watermark :markInfo="markInfo"></watermark>-->

    <!-- 问题引导 -->
    <div class="guideBox">
      <div class="guideBoxContent">
        <div class="headerRow">
          <span class='topBackBtn' @click="goLogin">
            <img src="../../assets/img/arrow-left.png" alt="返回" class="backArrow">
          </span>
          <p class="greeting">您好，我是智能客服{{ loginInfo.aiNickname }}</p>
        </div>
<!--        <div class="triangleLeft"></div>-->
<!--          <p class="question">您可以咨询“{{ loginInfo.knowledgeTypeNames }}”相关的问题</p>-->
        <p class="question">机票、外事问题都可以问我</p>
        <div class="avatarContainer">
          <img :src="profilePhoto" alt="系统" class="headPortrait" >
        </div>

        <!--          <div>-->
        <!--            <p class="label-text">此消息由智能客服机器人发送</p>-->
        <!--          </div>-->
      </div>
    </div>

    <!-- 中间层：白色大卡片（聊天主体） -->
    <div :class="['chatContentBox',{setarea:showNav}]" id="chatContentArea">
      <!-------------------历史信息---------------------->
      <!--      <history-chat :showHistoryBtn="showHistoryBtn" :currentDialogueNum="currentDialogueNum"-->
      <!--                    :profilePhoto="profilePhoto"-->
      <!--                    @findHistory="findHistoryFn"></history-chat>-->
      <history-chat :showHistoryBtn="showHistoryBtn" :currentDialogueNum="currentDialogueNum"
                    :profilePhoto="profilePhoto"
                    @findHistory="findHistoryFn"></history-chat>
      <!--------------------聊天内容------------------------>
      <div v-for="(item, index) in msglist" :key="index">
        <!------------机器人对话框------------>
        <div class="chat-model" v-if="item.csdrUtype===0&&item.csdrType!==62&&item.csdrType!==63">
          <!--头像和提示文本-->
            <div style="display: flex; align-items: center;">
              <img :src="profilePhoto" alt="系统" class="headPortrait" style="margin-right: 10px;">
              <p class="label-text" style="font-size: 12px;">此消息由智能客服机器人发送</p>
            </div>
          <!--对话-->
          <div :class="['chat-content', 'chat-content-l', { 'chat-content-thinking': item.msgNum === 'theThinkingMsgNum' }]">
            <!--            <div class="triangleLeft"></div>-->
            <!--消息内容-->
            <msgType :info="item" @question-click="handleRecommendQuestionClick"></msgType>
            <!--转人工-->
            <div v-if="item.csdrType===60||item.csdrType===61">
              <p>{{ item.csdrContent }}：
                <span @click="checkTime" class='manualService'>
                  <van-icon name="phone" class="phone"/>转人工
                </span>
              </p>
            </div>

            <!--评价-->
            <div v-if='item.csdrType===51'>
              <p class="evaluate-text-row">
                <span>{{ item.csdrContent }}</span>
                <span class="evaluateButton" @click="openEvaluate">
                  <span class="evaluate-btn-inner">
                    <img src="../../assets/img/sign.png" alt="评价" class="evaluate">
                    点击反馈
                  </span>
                </span>
              </p>
            </div>
          </div>
        </div>
        <!--人工服务分界线-->
        <div class="personLine" v-if="item.csdrType===63">
          <div class="separateLineBox">
            <span class="historyText">{{ item.csdrContent }}</span>
          </div>
        </div>
        <div class="personLine" v-if="item.csdrType===62">
          <div class="separateLineBox">
            <span class="historyText">人工服务中</span>
          </div>
        </div>
        <!------------客服对话框------------>
        <div class="chat-model chat-model-person"  style="display: flex; align-items: flex-start;" v-if="item.csdrUtype===2&&item.msgWithdrawStatus===0">
          <!--头像和提示文本-->
          <div style="display: flex; flex-direction: column;">
            <p class="label-text-person" style="font-size: 12px; margin-bottom: 5px;">人工客服</p>
            <img src="../../assets/img/live-agent.png" alt="客服" class="headPortrait-chat">
          </div>
          <div class="chat-content chat-content-l chat-content-person">
            <div class="triangleLeft"></div>
            <!--消息内容-->
            <msgType :info="item" @question-click="handleRecommendQuestionClick"></msgType>
          </div>
        </div>
        <!--被撤回后展示的消息-->
        <div v-if="item.msgWithdrawStatus===1" class="withdrawMsgBox">
          <p>{{ item.msgWithdrawHint }}</p>
        </div>
        <!------------用户对话框------------>
        <div class="chat-model" style="align-items: flex-end;" v-if="item.csdrUtype===1">
          <!--对话-->
          <div class="chat-content chat-content-r" v-if="item.csdrType !== 33">
            <div class="triangle"></div>
            <!--消息内容-->
            <msgType :info="item" @question-click="handleRecommendQuestionClick"></msgType>
          </div>
          <!--语音消息 -->
          <div class="chat-content chat-content-r voice-bubble" v-if="item.csdrType === 33">
            <div class="triangle"></div>
            <div class="voice-container" @click="playVoice(item)">
              <div class="voice-message" :class="{ 'playing': playingVoiceId === item.msgNum }">
                <span class="play-symbol"></span>
              </div>
              <span class="voice-length">{{ item.voiceDuration }}</span>
            </div>
          </div>

          <!--头像-->
          <div>
            <img src="../../assets/img/customer.png" alt="用户" class="headPortrait-person">
          </div>
        </div>
      </div>
      <!-----------------------评价----------------------->
      <!--              :autosize="evaluateAutosize"-->
      <van-action-sheet v-model="showEvaluate" title="反馈" class="evaluate-action-sheet">
        <div class="evaluateMain">
          <div class="evaluate-textarea-wrapper">
            <van-field
              :readonly="evaluateReadonly"
              v-model="evaluateData.feedbackContent"
              rows="4"
              clearable
              autosize
              border
              type="textarea"
              placeholder="请具体描述您所遇到的问题，以便我们更快解决您的问题~"
              maxlength="200"
              show-word-limit
              class="evaluate-textarea"
            />
          </div>
          <!-- 标签选项 -->
          <div class="evaluate-tags">
            <span
              v-for="tag in evaluateTags"
              :key="tag"
              class="tag-item"
              :class="{ active: selectedTags.includes(tag), disabled: evaluateReadonly }"
              @click="!evaluateReadonly && selectTag(tag)"
            >{{ tag }}</span>
          </div>
          <van-button type="info" class="submitEvaluate" @click="submitEvaluateFn" :disabled="evaluateReadonly">提交</van-button>
        </div>
      </van-action-sheet>
      <!-----------------------问题引导图标----------------------->
<!--      <div class="guideImage"  @click="findGuideFn">-->
<!--        &lt;!&ndash;      <div class="guideImage" v-if="ifGuideImage&&!guideBoxPopup" @click="findGuideFn">&ndash;&gt;-->
<!--        <img src="../../assets/img/backBtn.png" alt="" class="sendImg">-->
<!--      </div>-->

      <van-popup v-model="guideBoxPopup" position="right" round :style="{width: '80%', }"
                 :overlay-style="{backgroundColor: 'rgba(0,0,0,0.6)'}">
        <div class="guideBoxContent" style="margin: 40px 0 20px 15px">
                    <div class="triangleLeft"></div>
          <div class="debaoImgBox">
<!--            <div style="display: flex; align-items: center;">-->
<!--              <img :src="profilePhoto" alt="系统" class="debaoImg" style="margin-right: 10px;">-->
<!--              <p class="label-text">此消息由智能客服机器人发送</p>-->
<!--            </div>-->
            <p class="debaoTips">{{ loginInfo.aiNickname }}的提示</p>
          </div>
          <p>您好，我是智能客服-{{ loginInfo.aiNickname }}，您可以咨询“{{ loginInfo.knowledgeTypeNames }}”相关的问题。
          </p>
          <div>
            <van-field label="国家" readonly clickable required placeholder="点击选择国家" @click="showPicker=true" :value="value"></van-field>
            <van-popup v-model="showPicker" position="bottom">
              <!-- v-model.trim 对关键字进行去空处理 @input 输入框自身属性，对输入的值进行实时检测 -->
              <van-field clickable v-model.trim="keyvalue" left-icon="search" placeholder="搜索国家" @input="search"></van-field>
              <van-picker show-toolbar :columns="filterCountries" @confirm="onConfirm" @cancel="showPicker=false">
                <template #option="option">
                  <div style="display: flex; flex-direction: column; align-items: center;">
                    <div>{{ option.keCountryName }}</div>
                  </div>
                </template>
              </van-picker>
            </van-popup>
            <van-button round block type="primary" class="testQueryBtn" @click="queryCountryAttr" size="small">查询</van-button>
          </div>
        </div>
      </van-popup>

    </div>

    <!-- 人工客服按钮 -->
      <div class="manual-service-btn" :class="{ 'manual-service-btn-disabled': isAnswering }" @click="!isAnswering && checkTime" v-if="shouldShowManualServiceBtn">
      <img src="../../assets/img/live-agent.png" alt="人工客服" class="manual-service-avatar">
      <span class="manual-service-text">人工客服</span>
    </div>

    <!-- 推荐问题 -->
    <div class="recommend-box" style="margin-top: 4px;">
      <div class="recommend-content recommend-content-top">
        <div class="recommend-row">
          <div class="recommend-item" :class="{ 'recommend-item-disabled': isAnswering }" @click="!isAnswering && sendMessage('过境签证是否需要指纹')">
            <span class="recommend-icon">🔍</span>
            <span>过境签证是否需要指纹</span>
          </div>
          <div class="recommend-item" :class="{ 'recommend-item-disabled': isAnswering }" @click="!isAnswering && sendMessage('在机场行李托运，需要注意什么')">
            <span class="recommend-icon">✈️</span>
            <span>在机场行李托运，需要注意什么</span>
          </div>
          <div class="recommend-item" :class="{ 'recommend-item-disabled': isAnswering }" @click="!isAnswering && sendMessage('签证申请表')">
            <span class="recommend-icon">📄</span>
            <span>签证申请表</span>
          </div>
        </div>
      </div>
    </div>
    <div class="recommend-box recommend-box-item">
      <div class="recommend-content">
        <div class="recommend-row">
          <div class="recommend-item" :class="{ 'recommend-item-disabled': isAnswering }" @click="!isAnswering && sendMessage('签证资料')">
            <span class="recommend-icon">📋</span>
            <span>签证资料</span>
          </div>
          <div class="recommend-item" :class="{ 'recommend-item-disabled': isAnswering }" @click="!isAnswering && sendMessage('签证问题')">
            <span class="recommend-icon">❓</span>
            <span>签证问题</span>
          </div>
          <div class="recommend-item" :class="{ 'recommend-item-disabled': isAnswering }" @click="!isAnswering && sendMessage('签证生物采集')">
            <span class="recommend-icon">🧬</span>
            <span>签证生物采集</span>
          </div>
        </div>
      </div>
     </div>
    </div>
    <!-- 底层：底部输入框 -->
    <div class="input-container">
      <div class="input-wrapper">
        <input type="text" v-model="newMessage" placeholder="有问题尽管问我~" @focus="inputFocus" @blur="inputBlur"
               @touchstart="touchFocus"
               class="inputBox"
               @keyup.enter="sendMessage" ref="input"/>
        <div class="voice-record-btn" v-show="!isAnswering" @mousedown="startRecording" @mouseup="stopRecording" @touchstart="startRecording" @touchend="stopRecording" @contextmenu.prevent>
          <div class="voice-icon"></div>
        </div>
      </div>
      <span class="sendImgBox" :class="{ 'sending': isAnswering }">
        <div v-if="isAnswering && hasWebSocketResponse" class="pause-icon" @click="pauseMessage"></div>
        <img v-else-if="isAnswering && !hasWebSocketResponse" src="../../assets/img/sendBtn.png" alt="发送" class="sendImg sendImg-disabled">
        <img v-else src="../../assets/img/sendBtn.png" alt="发送" class="sendImg" @click="sendMessage">
      </span>
    </div>
    <!-- 语音录制状态提示 -->
    <div class="recording-status" v-if="recording">
      <div class="recording-dot"></div>
      <span>正在录制... {{ recordingTime }}s</span>
    </div>

    <!------------------------- 转人工排队弹窗（已移到循环外，正确位置）----------------------->
    <van-dialog v-model="queueUpDialog" title="友情提示" show-cancel-button
                :showConfirmButton="false" cancelButtonText="关闭" :closeOnClickOverlay="false" >
      <p class='queueUp'>{{ queueUpMsg }}</p>
    </van-dialog>
  </div>
</template>
<script>
import { ImagePreview, Toast } from 'vant'
import { cancelPhone,
  getConversation,
  getConversationInfo,
  getKnowledgeCountries,
  getQuestionList,
  isServicingTime,
  recordPhone,
  stopStreaming,
  submitEvaluate,
  uploadAudio
} from '../../service/getData'
import { getCheckLoginInfo, getConfig, getLoginInfo } from '../../util/auth'
import HistoryChat from '../../components/chat/historyChat'
import attachment from '../../components/chat/attachment'
import msgType from '../../components/chat/msgType'
import watermark from '../../components/chat/watermark'
import { changeBaseImg, checkExpiredFn } from '../../assets/js/common'

export default {
  name: 'chatDetail',
  components: { HistoryChat, attachment, msgType, watermark },
  data () {
    return {
      loginInfo: getLoginInfo(), // 登录成功后，后端返回的信息
      accountInfo: JSON.parse(sessionStorage.getItem('accountInfo')),
      profilePhoto: sessionStorage.getItem('profilePhoto') || require('../../assets/img/ai-customer-service.png'), // base64格式用户头像
      markInfo: { // 水印内容
        msg: '智旅途AI智能',
        domId: 'chatContentArea'
      },
      showNav: false, // 是否展示导航栏
      /* -----------------------顶部问题列表--------------------------- */
      // 问题列表（所有层级）
      allQuestions: [],
      // 问题列表（当前层级）
      questionList: [{ questionLevel: 1 }],
      currentLi: false, // 是否显示当前问题样式
      /* -----------------------聊天信息--------------------------- */
      currentDialogueNum: '', // 当前会话id
      showHistoryBtn: false, // 是否显示历史消息按钮
      showEvaluate: false, // 是否显示评分
      evaluateData: {
        csdrId: '',
        feedbackScore: 0, // 评分
        feedbackContent: '' // 评价
      },
      evaluateAutosize: {
        maxHeight: 100,
        minHeight: 100
      },
      evaluateReadonly: false, // 是否禁止评论
      selectedTags: [], // 选中的反馈标签（多选）
      evaluateTags: ['回答不准确', '没解决问题', '闪退', '卡顿'], // 评价标签列表
      // 聊天内容
      msglist: [],
      newMessage: '',
      chatContent: null,
      ifGuideImage: false,
      guideBoxPopup: false,
      queueUpDialog: false, // 是否显示排队弹窗
      queueUpMsg: '您的转人工服务已受理，请稍等。',
      // 下拉框选择的值
      value: '',
      // 搜索框的关键字
      keyvalue: '',
      // 过滤数组
      filterCountries: null,
      // 原数组
      countries: [],
      showPicker: false,
      // 语音录制相关
      recording: false,
      mediaRecorder: null,
      audioChunks: [],
      audioContext: null,
      mediaStream: null,
      recordingTime: 30, // 语音录制最大时长（秒）
      recordingTimer: null, // 录制倒计时定时器
      // 语音播放相关
      playingVoiceId: null,
      audioElement: null,
      // WebSocket状态相关1
      isAnswering: false,
      // 流式任务ID
      difyTaskId: '',
      // 流式响应是否已停止
      streamingStopped: false,
      // 是否已收到WebSocket响应
      hasWebSocketResponse: false,
      // WebSocket响应超时定时器
      responseTimeout: null
    }
  },
  computed: {
    // 判断是否显示人工客服按钮
    shouldShowManualServiceBtn () {
      const hasManualService = this.msglist.some(item => item.csdrType === 62)
      const hasManualServiceEnd = this.msglist.some(item => item.csdrType === 51)
      // 打印所有消息的 csdrType
      console.log('=== 消息列表 csdrType 详情 ===')
      this.msglist.forEach((item, index) => {
        console.log(`消息[${index}]: csdrType=${item.csdrType}, csdrContent=${item.csdrContent}`)
      })
      console.log('hasManualService (csdrType=62):', hasManualService)
      console.log('hasManualServiceEnd (csdrType=63):', hasManualServiceEnd)
      console.log('32323', hasManualService, hasManualServiceEnd)
      // 如果人工服务已结束，显示按钮
      if (hasManualServiceEnd) {
        return true
      }

      // 如果正在人工服务中，不显示按钮
      if (hasManualService) {
        return false
      }

      // 其他情况显示按钮
      return true
    }
  },
  mounted () {
    let checkLoginInfo = getCheckLoginInfo()
    if (checkLoginInfo && checkLoginInfo !== '' && checkLoginInfo !== null && checkLoginInfo !== undefined) {
      // 获取问题列表
      this.getQuestionListFn()
      // 获取头像将头像转成base64并存储
      this.getBase64Img()
    } else {
      this.$router.push({
        path: '/error',
        query: {
          msg: '网络出现异常，请返回后重新进入应用。'
        }
      })
    }

    this.chatContent = document.getElementsByClassName('chatContentBox')[0]
    this.chatContent.addEventListener('scroll', this.initScroll)

    // 是否展示导航栏，返回按钮
    this.getConfigInfoFn()

    //  挂载时，将原数组给到需要过滤的数组
    getKnowledgeCountries().then(res => {
      if (res.code === 0) {
        this.countries = res.data
        this.filterCountries = this.countries
      }
    })
  },
  beforeDestroy () {
    // 退出页面销毁socket
    this.$socketApi.closeWebSocket()
    // 退出页面销毁addEventListener监听事件
    this.chatContent.removeEventListener('scroll', this.initScroll)
  },
  methods: {
    handleRecommendQuestionClick (question) {
      if (question) {
        this.newMessage = question
        this.sendMessage()
      }
    },
    hideDialog (val) {
      this.$store.commit('setShowAllBtn', false)
    },
    // 获取头像将头像转成base64并存储
    async getBase64Img () {
      if (this.loginInfo.aiAvatar) {
        let url = await changeBaseImg(this.$originApi + this.loginInfo.aiAvatar)
        console.log('头像完整URL:', url)
        if (url !== null) {
          sessionStorage.setItem('profilePhoto', url)
          this.profilePhoto = url
        }
      }
    },
    // 跳转登录
    goLogin () {
      this.$router.push({ name: 'login' })
    },
    // 查看问题引导
    findGuideFn () {
      this.guideBoxPopup = true
    },
    // 点击查看历史记录回调
    findHistoryFn (val) {
      this.initScroll()
    },
    // 监听页面滚动，是否展示查看问题引导图标
    initScroll (e) {
      let guideBoxHeight = document.getElementsByClassName('guideBox')[0]
      if ((guideBoxHeight.offsetTop + guideBoxHeight.offsetHeight > this.chatContent.scrollTop) && (guideBoxHeight.offsetTop < this.chatContent.scrollTop + this.chatContent.clientHeight)) {
        // console.log('进入可视区域')
        this.ifGuideImage = false
      } else {
        // console.log('离开可视区域')
        this.ifGuideImage = true
      }
    },
    /* -----------------------顶部问题列表--------------------------- */
    // 获取问题列表
    getQuestionListFn () {
      let params = {
        companyAccount: this.loginInfo.companyAccount
      }
      getQuestionList(params).then(res => {
        if (res.code === 0) {
          this.allQuestions = res.data
          // 初始化设置问题列表
          this.initQuestionList(this.allQuestions)
          // 获取当前会话信息
          this.getConversationInfoFn()
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 初始化设置问题列表
    initQuestionList (allQuestions, level = 1) {
      // 给问题的每层添加默认参数
      // questionLevel来标明层级
      // currentLi代表是否选中当前问题
      allQuestions.forEach(item => {
        item.questionLevel = level
        item.currentLi = false
        if (item.subs && item.subs.length > 0) {
          this.initQuestionList(item.subs, level + 1)
        }
      })
      // 赋值给当前问题列表
      this.questionList = allQuestions
    },
    // 获取下一级问题，如果没有下一级，则为当前问题
    async getQuestion (item, questionsArr) {
      for (const i of questionsArr) {
        if (i.ktId === item.ktId) {
          if (i.subs && i.subs.length > 0) {
            // 赋值当前问题列表
            this.questionList = i.subs
            // 设置选中样式
            this.setCurrentLi(-1)
          } else {
            if (this.guideBoxPopup) {
              this.guideBoxPopup = false
            }
            // 当前最终提问
            // 设置选中样式
            this.setCurrentLi(item.ktId)

            // 验证token是否过期，过期重新登录
            checkExpiredFn()

            // 判断当前是否存在socket对象
            // if (this.$socketApi.isConnectFn()) {
            //   this.$socketApi.closeWebSocket()
            // }

            // 初始化socket
            this.$socketApi.initWebSocket(this.getsocketResult)

            // 发送当前提问信息给socket
            let msgNum = this.setMsgNum() // 消息编号
            this.$socketApi.sendSock({
              msgType: 20,
              context: item.ktId,
              msgNum
            })
          }
        } else if (i.subs && i.subs.length > 0) {
          this.getQuestion(item, i.subs)
        }
      }
    },
    // 问题列表返回按钮
    returnBtn () {
      this.getParents(this.questionList[0].ktPId, this.allQuestions)
    },
    // 获取上一级的所有数据
    getParents (id, allQuestions) {
      allQuestions.forEach(item => {
        if (item.ktId === id) {
          // 设置问题列表
          this.questionList = allQuestions
        } else if (item.subs && item.subs.length > 0) {
          this.getParents(id, item.subs)
        }
      })
    },
    // 设置选中样式
    setCurrentLi (id) {
      this.allQuestions.forEach(item => {
        if (item.ktId === id) {
          item.currentLi = true
        } else {
          item.currentLi = false
        }
      })
      this.questionList.forEach(item => {
        if (item.ktId === id) {
          item.currentLi = true
        } else {
          item.currentLi = false
        }
      })
      this.$forceUpdate()
    },
    /* -----------------------聊天信息--------------------------- */
    // 获取当前会话id和问题id
    getConversationInfoFn () {
      let params = {
        groupCompanyCode: this.loginInfo.groupCompanyCode,
        uniqueCode: this.loginInfo.uniqueCode,
        companyAccount: this.accountInfo
      }
      getConversationInfo(params).then(res => {
        if (res.code === 0) {
          let dialogueNum = res.data.dialogueNum // 会话id
          let context = res.data.context // 当前问题id
          // 如果有会话id，初始化一个websocket
          if (dialogueNum !== '' && dialogueNum !== null && dialogueNum !== undefined) {
            this.currentDialogueNum = dialogueNum
            this.$socketApi.initWebSocket(this.getsocketResult)
            // 获取当前会话内容
            this.getConversationFn(dialogueNum)
          }
          // 如果存在当前问题，选中当前问题
          if (context !== '' && context !== null && context !== undefined) {
            this.getParents(context, this.allQuestions)
            // 设置选中样式
            this.setCurrentLi(context)
          }
          // 检查是否有历史记录
          this.showHistoryBtn = res.data.hasHistoryDialogue
          // 保存评价id
          if (res.data.length > 0) {
            this.evaluateData.csdrId = res.data[0].csdrId
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 获取当前会话内容
    getConversationFn (csdCode) {
      let params = { csdCode }
      getConversation(params).then(res => {
        if (res.code === 0) {
          // 处理语音消息，为其生成 audioUrl
          this.msglist = res.data.dialogueRecordList.map(item => {
            if (item.csdrType === 33) {
              // 如果是语音消息，且有 csdaBase 字段，生成 audioUrl
              if (item.csdaBase) {
                item.audioUrl = `data:audio/wav;base64,${item.csdaBase}`
              }
              // 设置语音时长
              if (item.csdrSpeechDuration) {
                item.voiceDuration = Math.round(item.csdrSpeechDuration) + '"'
              } else {
                item.voiceDuration = '2"'
              }
            }
            return item
          })
          // 设置滚动条到最底部
          setTimeout(function () {
            let chatArea = document.getElementById('chatContentArea')
            chatArea.scrollTo(0, chatArea.scrollHeight)
          }, 1)
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 发送消息
    sendMessage (message) {
      const msg = typeof message === 'string' ? message : this.newMessage
      if (msg) {
        const isWbConnect = this.$socketApi.isConnectFn()
        if (!isWbConnect) {
          console.log('Socket is not connected') // 替代debugger的日志输出
          // 验证token是否过期，过期重新登录
          checkExpiredFn()
          // 如果没有开启socket，则初始化socket
          this.$socketApi.initWebSocket(this.getsocketResult)
        }

        // 发送消息时禁用推荐问题
        this.isAnswering = true
        // 重置流式响应停止状态
        this.streamingStopped = false
        // 重置WebSocket响应状态
        this.hasWebSocketResponse = false

        let msgNum = this.setMsgNum() // 消息编号
        const result = this.$socketApi.sendSock({
          msgType: 31,
          message: msg,
          msgNum
        })
        if (result === 'closed') {
          // 链接关闭提示
          this.msglist.push({csdrType: 31, csdrContent: '请您先选择问题类别。', csdrUtype: 0, msgWithdrawStatus: 0})
          // 恢复推荐问题1
          this.isAnswering = false
          // 重新初始化WebSocket
          checkExpiredFn()
          this.$socketApi.initWebSocket(this.getsocketResult)
        } else {
          // 当前默认发送文本消息
          this.msglist.push({csdrType: 31, csdrContent: msg, csdrUtype: 1, msgNum, msgWithdrawStatus: 0})

          const index62 = this.getMsgTypeIndex(62)
          if (index62 !== -1) {
            const index51 = this.getMsgTypeIndex(51)
            if (index51 === -1 || index51 < index62) {
              // if (!message) {
              //   this.newMessage = ''
              // }
              this.newMessage = ''
              return
            }
          }
          // eslint-disable-next-line standard/object-curly-even-spacing
          this.msglist.push({
            csdrType: 31,
            csdrContent: '思考中...',
            csdrUtype: 0,
            msgNum: 'theThinkingMsgNum',
            msgWithdrawStatus: 0
          })
          this.startDelayClearThinking()

          // 设置WebSocket响应超时定时器
          this.startResponseTimeout()
        }
        this.newMessage = ''
      }
    },
    getMsgTypeIndex (theMsgType) {
      return this.msglist.reduceRight((acc, item, index) => {
        return acc !== -1 ? acc : (item.csdrType === theMsgType ? index : -1)
      }, -1)
    },
    // 延时移除Thinking
    startDelayClearThinking () {
      // 清除之前的定时器（如果存在）
      if (this.timer) {
        clearTimeout(this.timer)
      }

      // 设置延时操作
      this.timer = setTimeout(() => {
        const index = this.msglist.findIndex(item => item.msgNum === 'theThinkingMsgNum')
        if (index !== -1) {
          this.msglist.splice(index, 1) // 删除指定编号的消息
        }
      }, 30000) // 30秒后执行
    },
    // 开始WebSocket响应超时定时器
    startResponseTimeout () {
      // 清除之前的定时器（如果存在）
      this.clearResponseTimeout()

      // 设置30秒超时
      this.responseTimeout = setTimeout(() => {
        // 超时处理：恢复正常状态1
        this.isAnswering = false
        this.streamingStopped = true
        this.hasWebSocketResponse = false

        // 移除思考中消息
        const index = this.msglist.findIndex(item => item.msgNum === 'theThinkingMsgNum')
        if (index !== -1) {
          this.msglist.splice(index, 1)
        }

        console.log('WebSocket响应超时，已恢复正常状态')
      }, 30000) // 30秒后执行
    },
    // 清除WebSocket响应超时定时器
    clearResponseTimeout () {
      if (this.responseTimeout) {
        clearTimeout(this.responseTimeout)
        this.responseTimeout = null
      }
    },
    // 设置每条消息的消息编号
    setMsgNum () {
      let msgNum = ''
      const dialogueNum = this.currentDialogueNum
      if (dialogueNum) {
        const lastChars = dialogueNum.substring(dialogueNum.length - 4) // 会话编号后4位
        const timestamp = new Date().getTime() // 时间戳
        const randomInt = Math.floor(Math.random() * 900) + 100 // 三位随机数
        msgNum = lastChars + '-' + timestamp + '-' + randomInt
      }
      return msgNum
    },
    // 接收服务端发送过来的消息
    /*
    * 发送人类型csdrUtype：0：系统；1：用户；2：客服
    * 发送内容类型csdrType:10-连接；19-结束连接；90-心跳；20-上下文；31-文本；32-富文本；33-语音；41-附件；42-图片；51-评分；52-点赞 53-撤回消息 61-转人工 62-web端主动转人工；
    *
    * */
    getsocketResult (data) {
      let info = JSON.parse(data)
      this.currentDialogueNum = info.dialogueNum

      // 标记已收到WebSocket响应
      this.hasWebSocketResponse = true

      // 清除WebSocket响应超时定时器
      this.clearResponseTimeout()

      // 提取difyTaskId
      if (info.difyTaskId !== undefined) {
        this.difyTaskId = info.difyTaskId
      }
      // 根据difyEvent更新回答状态1
      if (info.difyEvent !== undefined) {
        // difyEvent不是message_end表示正在回答，禁用推荐问题
        // difyEvent是message_end表示回答完毕，启用推荐问题
        this.isAnswering = info.difyEvent !== 'message_end'
      }
      // 检查消息是否已存在，避免重复
      // const exists = this.msglist.some(item => item.msgNum === info.msgNum && item.csdrType === info.msgType)
      // if (exists) {
      //   return // 消息已存在，直接返回
      // }
      // 删除正在思考的消息
      if (info.msgType !== 10) {
        const index = this.msglist.findIndex(item => item.msgNum === 'theThinkingMsgNum')
        if (index !== -1) {
          this.msglist.splice(index, 1) // 删除指定编号的消息
        }
      }
      // 根据消息类型进行消息处理
      if (info.msgType === 20 || info.msgType === 31 || info.msgType === 32 || info.msgType === 51 || info.msgType === 60 || info.msgType === 61 || info.msgType === 62 || info.msgType === 63) {
        // 普通文本类消息
        this.msglist.push({
          csdrType: info.msgType,
          csdrContent: info.message,
          csdrUtype: info.csdrUtype,
          lineLimit: 3,
          msgWithdrawStatus: 0,
          msgNum: info.msgNum
        })
        if (info.msgType === 51) {
          // 保存评价id
          this.evaluateData.csdrId = info.scoreCsdrId
        }
        if (info.msgType === 62) {
          this.queueUpDialog = false
        }
      } else if (info.msgType === 35) {
        // 如果流式响应已停止，不再处理流式消息
        // if (this.streamingStopped) {
        //   return
        // }
        const index = this.msglist.findIndex(item => item.msgNum === info.msgNum)
        if (index !== -1) {
          if (info.difyEvent !== 'message_end') {
            // 更新已有消息内容
            this.$set(this.msglist, index, {
              ...this.msglist[index],
              csdrContent: this.msglist[index].csdrContent + info.message
            })
          }
        } else {
          // 添加新消息
          this.msglist.push({
            csdrType: info.msgType,
            csdrContent: info.message,
            csdrUtype: info.csdrUtype,
            lineLimit: 3,
            msgWithdrawStatus: 0,
            msgNum: info.msgNum
          })
        }
      } else if (info.msgType === 41) {
        // 附件类消息
        this.msglist.push({
          csdrType: info.msgType,
          csdrAtt: info.fileUrl,
          csdrAttName: info.fileName,
          csdrUtype: info.csdrUtype,
          msgWithdrawStatus: 0,
          msgNum: info.msgNum,
          csdrAttDownload: info.csdrAttDownload
        })
      } else if (info.msgType === 42) {
        // 图片类消息
        this.msglist.push({
          csdrType: info.msgType,
          csdrAtt: info.fileUrl,
          csdrUtype: info.csdrUtype,
          msgWithdrawStatus: 0,
          msgNum: info.msgNum
        })
      } else if (info.msgType === 33) {
        // 语音类消息
        this.msglist.push({
          csdrType: info.msgType,
          csdrContent: '[语音消息]',
          csdrUtype: info.csdrUtype,
          msgWithdrawStatus: 0,
          msgNum: info.msgNum
        })
      } else if (info.msgType === 19) {
        // 关闭socket
        this.$socketApi.closeWebSocket()
        // 初始化问题列表
        this.getQuestionListFn()
      } else if (info.msgType === 71) {
        // 转人工排队
        this.queueUpDialog = true
      } else if (info.msgType === 53) {
        // 消息撤回后提示语
        let msgArr = this.msglist
        msgArr.forEach(i => {
          if (i.msgNum === info.withdrawMsgNum) {
            i.msgWithdrawHint = info.message
            i.msgWithdrawStatus = 1
          }
        })
        this.msglist = msgArr
      }
    },
    // 输入框聚焦后，设置滚动条到最底部
    inputFocus () {
      // document.getElementsByClassName('input-container')[0].scrollIntoView()
      if (this.chatContent.scrollHeight > this.chatContent.clientHeight) {
        // 设置滚动条到最底部
        this.chatContent.scrollTop = this.chatContent.scrollHeight
      }

      // 监听如果是安卓手机，那么聊天输入框上移，反之不用
      // var u = navigator.userAgent
      // if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) { // 安卓手机
      //   document.getElementsByClassName('input-container')[0].style.bottom = '300px'
      // } else {
      //   // window.scroll(0, 0)// 苹果
      // }
    },
    inputBlur () {
      // 失去焦点的时候，进行触发
      // 监听如果是安卓手机，那么聊天输入框恢复底部位置，反之不用
      // var u = navigator.userAgent
      // if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) { // 安卓手机
      //   document.getElementsByClassName('input-container')[0].style.bottom = '0'
      // } else {
      //   // window.scroll(0, 0)// 苹果
      // }
    },
    // 查看大图
    showImg (img) {
      ImagePreview([img])
    },
    // 查看当前聊天消息全部信息
    watchDetail (index) {
      this.msglist[index].lineLimit = 'inherit'
    },
    // 打开评价弹窗
    openEvaluate () {
      this.showEvaluate = true
    },
    // 改变评分
    changeEvaluate (val) {
      console.log('val', val)
    },
    // 选择反馈标签（多选）
    selectTag (tag) {
      const index = this.selectedTags.indexOf(tag)
      if (index > -1) {
        this.selectedTags.splice(index, 1)
      } else {
        this.selectedTags.push(tag)
      }
    },
    // 提交评价
    submitEvaluateFn () {
      let ifPass = true
      if (this.evaluateData.csdrId === '' || this.evaluateData.csdrId === null || this.evaluateData.csdrId === undefined) {
        Toast.fail('缺少评价id')
        ifPass = false
      } else if (this.evaluateData.feedbackContent === '' || this.evaluateData.feedbackContent.match(/^\s+$/) || this.evaluateData.feedbackContent === null || this.evaluateData.feedbackContent === undefined) {
        Toast.fail('请填写评价内容')
        ifPass = false
      }

      if (ifPass) {
        // 构建标签字符串，选中为 "名称_1"，未选中为 "名称_0"
        const feedbackTags = this.evaluateTags.map(tag => {
          const isSelected = this.selectedTags.includes(tag)
          return `${tag}_${isSelected ? 1 : 0}`
        }).join(',')

        let params = {
          ...this.evaluateData,
          feedbackTags: feedbackTags // 传递所有标签及其选中状态
        }
        submitEvaluate(params).then(res => {
          if (res.code === 0) {
            this.showEvaluate = false
            this.evaluateReadonly = true
          } else {
            Toast.fail(res.msg)
          }
        })
      }
    },
    // 记录转人工（toManualType：1.右上角转人工2.当前会话转人工）
    recordPhoneFn (toManualType) {
      let params = {
        clientId: this.accountInfo + '-' + this.loginInfo.groupCompanyCode + '-' + this.loginInfo.uniqueCode,
        dialogueNum: this.currentDialogueNum,
        toManualType
      }
      recordPhone(params).then(res => {
        if (res.code === 0) {
          this.queueUpMsg = '您的转人工服务已受理，请稍等。'
          this.queueUpDialog = true
        } else if (res.code === 1010090010) {
          this.queueUpMsg = '本次咨询已结束，期待下次咨询中为您服务。'
          this.queueUpDialog = true
        } else if (res.code === 1010010080) {
          this.queueUpMsg = '当前客服人员正在为您服务。'
          this.queueUpDialog = true
        } else if (res.code === 1010010090) {
          this.queueUpMsg = '已为您登记人工服务并加急排队，无需重复操作，人工客服正在陆续接入中，请耐心等候片刻。'
          this.queueUpDialog = true
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 取消转人工
    cancelPhoneFn () {
      let params = {
        clientId: this.accountInfo + '-' + this.loginInfo.groupCompanyCode + '-' + this.loginInfo.uniqueCode,
        dialogueNum: this.currentDialogueNum
      }
      cancelPhone(params).then(res => {
        if (res.code === 0) {
          this.queueUpDialog = false
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 是否展示导航栏，返回按钮
    getConfigInfoFn () {
      let configInfo = getConfig()
      if (configInfo) {
        this.showNav = configInfo.setting.settingsShowNavigationBar
        this.showBackBtn = configInfo.setting.settingsShowBackButton
      }
    },
    // 重新聚焦
    touchFocus () {
      document.getElementsByClassName('inputBox')[0].focus()
    },
    // 排队检查时间
    checkTime () {
      // 如果没有 WebSocket 连接，先初始化
      const isWbConnect = this.$socketApi.isConnectFn()
      if (!isWbConnect || !this.currentDialogueNum) {
        // 验证token是否过期，过期重新登录
        checkExpiredFn()
        // 初始化socket
        this.$socketApi.initWebSocket(this.getsocketResult)

        // 等待 WebSocket 连接并获取到 dialogueNum
        // 使用轮询方式检查
        let retryCount = 0
        const maxRetries = 10
        const checkDialogueNum = setInterval(() => {
          if (this.currentDialogueNum || retryCount >= maxRetries) {
            clearInterval(checkDialogueNum)
            if (this.currentDialogueNum) {
              // 获取到 dialogueNum 后继续执行
              this.continueToManualService()
            } else {
              Toast.fail('会话初始化失败，请稍后重试')
            }
          }
          retryCount++
        }, 500)
        return
      }

      // 直接执行
      this.continueToManualService()
    },
    // 继续执行转人工逻辑
    continueToManualService () {
      isServicingTime().then(res => {
        if (res.code === 0) {
          if (res.data.inServiceTiming) {
            // 转人工
            this.recordPhoneFn(2)
          } else {
            if (res.data.workday) {
              // 工作日非上班时间段
              this.queueUpMsg = `抱歉，当前为非上班时段，请于${res.data.serviceTiming}咨询人工服务，感谢您的理解。`
              this.queueUpDialog = true
            } else {
              // 非工作日
              this.queueUpMsg = `抱歉，当前为非工作日，请于工作日咨询人工服务，感谢您的理解。`
              this.queueUpDialog = true
            }
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },

    // 输入框搜索方法
    search () {
      // 对过滤数组进行操作，返回符合条件的数组
      this.filterCountries = this.countries.filter((params) => {
        return params.keCountryName.includes(this.keyvalue)
      })
    },
    // 弹窗方法
    onConfirm (value) {
      this.value = value.keCountryName
      this.showPicker = false
    },
    queryCountryAttr () {
      if (this.guideBoxPopup) {
        this.guideBoxPopup = false
      }
      // 验证token是否过期，过期重新登录
      checkExpiredFn()

      const isWbConnect = this.$socketApi.isConnectFn()
      if (!isWbConnect) {
        console.log('Socket is not connected') // 替代debugger的日志输出
        // 验证token是否过期，过期重新登录
        checkExpiredFn()
        // 如果没有开启socket，则初始化socket
        this.$socketApi.initWebSocket(this.getsocketResult)
      }

      let msgNum = this.setMsgNum() // 消息编号
      this.$socketApi.sendSock({
        msgType: 22,
        message: this.value,
        msgNum
      })
      this.msglist.push({ csdrType: 31, csdrContent: '您选择了' + this.value + '，正在返回相关的签证资料', csdrUtype: 0, msgWithdrawStatus: 0 })
    },
    // 开始录制语音
    startRecording () {
      this.recording = true
      this.recordingTime = 30 // 重置倒计时
      this.audioChunks = []

      // 启动倒计时
      this.recordingTimer = setInterval(() => {
        if (this.recordingTime > 0) {
          this.recordingTime--
        } else {
          // 时间到，自动停止录制
          this.stopRecording()
        }
      }, 1000)

      navigator.mediaDevices.getUserMedia({ audio: true })
        .then(stream => {
          this.mediaStream = stream
          this.mediaRecorder = new MediaRecorder(stream)

          this.mediaRecorder.ondataavailable = event => {
            if (event.data.size > 0) {
              this.audioChunks.push(event.data)
            }
          }

          this.mediaRecorder.start()
        })
        .catch(error => {
          console.error('Error accessing microphone:', error)
          Toast.fail('无法访问麦克风，请检查权限设置')
          this.recording = false
          // 清除倒计时
          if (this.recordingTimer) {
            clearInterval(this.recordingTimer)
            this.recordingTimer = null
          }
        })
    },
    // 停止录制语音
    stopRecording () {
      // 清除倒计时
      if (this.recordingTimer) {
        clearInterval(this.recordingTimer)
        this.recordingTimer = null
      }

      if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
        this.mediaRecorder.stop()

        this.mediaRecorder.onstop = () => {
          const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' })
          this.sendVoiceMessage(audioBlob)

          // 停止媒体流
          if (this.mediaStream) {
            this.mediaStream.getTracks().forEach(track => track.stop())
          }

          this.recording = false
        }
      } else {
        this.recording = false
      }
    },
    // 将Blob转换为Base64
    blobToBase64 (blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => {
          // 移除data URL前缀，只保留纯base64数据
          const base64String = reader.result.split(',')[1]
          resolve(base64String)
        }
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    },
    // 计算音频时长
    getAudioDuration (audioBlob) {
      return new Promise((resolve) => {
        const audio = new Audio()
        audio.onloadedmetadata = () => {
          resolve(audio.duration)
        }
        audio.src = URL.createObjectURL(audioBlob)
      })
    },
    // 格式化时长为微信风格（如：2"）
    formatDuration (seconds) {
      return Math.round(seconds) + '"'
    },
    // 发送语音消息
    async sendVoiceMessage (audioBlob) {
      // 发送消息时禁用推荐问题
      this.isAnswering = true
      // 重置流式响应停止状态
      this.streamingStopped = false
      // 重置WebSocket响应状态
      this.hasWebSocketResponse = false

      let msgNum = this.setMsgNum()

      try {
        // 计算音频时长
        const duration = await this.getAudioDuration(audioBlob)
        const formattedDuration = this.formatDuration(duration)

        // 将音频文件转换为base64
        const base64Audio = await this.blobToBase64(audioBlob)

        // 创建完整的data URL用于播放
        const audioUrl = `data:audio/wav;base64,${base64Audio}`

        // 调用音频上传接口
        const audioData = {
          csdaUtype: 1, // 用户发送
          csdaBase: base64Audio,
          csdaSpeechDuration: Math.round(duration)
        }

        const uploadResult = await uploadAudio(audioData)
        console.log('音频上传结果:', uploadResult)

        // 添加语音消息到聊天列表
        this.msglist.push({ csdrType: 33, csdrContent: '[语音消息]', csdrUtype: 1, msgNum, msgWithdrawStatus: 0, audioUrl: audioUrl, voiceDuration: formattedDuration })

        // 发送消息到socket
        const result = this.$socketApi.sendSock({
          msgType: 33,
          message: uploadResult.csdaText || '[语音消息]',
          msgNum,
          csdaId: uploadResult.csdaId
        })

        if (result === 'closed') {
          // 链接关闭，重新初始化WebSocket
          checkExpiredFn()
          this.$socketApi.initWebSocket(this.getsocketResult)
          // 恢复推荐问题1
          this.isAnswering = false
          // 链接关闭提示
          this.msglist.push({ csdrType: 31, csdrContent: '请您先选择问题类别。', csdrUtype: 0, msgWithdrawStatus: 0 })
        } else {
          // 检查是否存在转人工消息
          const index62 = this.getMsgTypeIndex(62)
          if (index62 !== -1) {
            const index51 = this.getMsgTypeIndex(51)
            if (index51 === -1 || index51 < index62) {
              return
            }
          }
          // 添加"思考中..."消息
          this.msglist.push({ csdrType: 31, csdrContent: '思考中...', csdrUtype: 0, msgNum: 'theThinkingMsgNum', msgWithdrawStatus: 0 })
          this.startDelayClearThinking()

          // 设置WebSocket响应超时定时器
          this.startResponseTimeout()
          // 统一在这里清空输入框（修复点）
          this.newMessage = ''
        }
      } catch (error) {
        console.error('Error sending voice message:', error)
        Toast.fail('发送语音消息失败')
        // 发送失败时恢复推荐问题1
        this.isAnswering = false
      }
    },
    // 播放语音消息
    playVoice (item) {
      // 停止当前正在播放的语音
      if (this.audioElement) {
        this.audioElement.pause()
        this.audioElement = null
        this.playingVoiceId = null
      }

      // 如果点击的是正在播放的语音，则停止播放
      if (this.playingVoiceId === item.msgNum) {
        this.playingVoiceId = null
        return
      }

      // 创建新的音频元素
      this.audioElement = new Audio()

      // 设置音频源（这里使用模拟数据，实际应该使用服务器返回的音频URL）
      // 对于用户发送的语音，使用本地存储的audioUrl
      if (item.audioUrl) {
        this.audioElement.src = item.audioUrl
      } else {
        // 对于机器人回复的语音，使用模拟的音频URL
        // 实际项目中应该从接口获取
        this.audioElement.src = 'https://example.com/voice.mp3'
      }

      // 开始播放
      this.audioElement.play()

      // 设置当前播放的语音ID
      this.playingVoiceId = item.msgNum

      // 监听播放结束事件
      this.audioElement.onended = () => {
        this.playingVoiceId = null
        this.audioElement = null
      }

      // 监听播放错误事件
      this.audioElement.onerror = () => {
        console.error('Error playing voice message')
        Toast.fail('播放语音失败')
        this.playingVoiceId = null
        this.audioElement = null
      }
    },
    // 暂停消息
    pauseMessage () {
      // 清除WebSocket响应超时定时器
      this.clearResponseTimeout()

      if (this.difyTaskId) {
        console.log('停止流式响应参数:', {
          taskId: this.difyTaskId,
          userName: this.loginInfo.uniqueCode
        })
        // 调用停止流式响应接口
        stopStreaming({
          taskId: this.difyTaskId,
          userName: this.loginInfo.uniqueCode
        }).then(res => {
          if (res.code === 0) {
            console.log('停止流式响应成功')
            // 停止后启用推荐问题1
            this.isAnswering = false
            // 标记流式响应已停止
            // this.streamingStopped = true
            // 删除思考中的消息
            const index = this.msglist.findIndex(item => item.msgNum === 'theThinkingMsgNum')
            if (index !== -1) {
              this.msglist.splice(index, 1)
            }
          } else {
            console.error('停止流式响应失败:', res.msg)
          }
        }).catch(err => {
          console.error('停止流式响应错误:', err)
        })
      }
    }
  },
  watch: {
    msglist: {
      handler (val, old) {
        if (this.chatContent.scrollHeight > this.chatContent.clientHeight) {
          // 设置滚动条到最底部
          this.$nextTick(() => {
            this.chatContent.scrollTop = this.chatContent.scrollHeight
          })
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.chat {
  width: 100%;
  height: 100vh;
  background: linear-gradient(180deg, rgba(0, 45, 162, 1) 0%, rgba(0, 45, 162, 1) 28%, #f0f0f0 28%, #f0f0f0 100%);
  /* overflow: hidden; */
  font-size: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  //padding: 20px;
  box-sizing: border-box;
  padding: 20px 0px;
}

.topNav {
  position: relative;
  background: #fff;
  height: 40px;
  text-align: center;
  line-height: 40px;
}

.chatContentBox {
  width: 100%;
  flex: 1;
  padding: 0rem 0.64rem 0.2rem 0.64rem;
  overflow-y: scroll;
  overflow-x: hidden;
  border-radius: 0;
  box-sizing: border-box;
  //background: linear-gradient(180deg, #EBECEE 0%, #FFFFFF 60%);
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  position: relative;
  margin-top: -1px;
  border-top: none;
}

.recommend-box {
  width: 100%;
  //padding: 10px 0;
  box-sizing: border-box;
  background: transparent;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
  margin-top: auto;
  padding: 0 18px;
}
.recommend-box-item{
  margin-bottom: 20px;
}

.recommend-header {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: left;
}

.recommend-content {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 7px;
  -webkit-overflow-scrolling: touch;
  max-width: 100%;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  height: 30px;
}

.recommend-content::-webkit-scrollbar {
  display: none;
}
.recommend-content-top {
  padding-bottom: 0px;
}

.recommend-row {
  display: flex;
  gap: 0px;
  //margin-bottom: 0px;
}

.recommend-item {
  background-color: #f0f0f0;
  padding: 0 4px;
  border-radius: 15px;
  font-size: 9px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  box-sizing: border-box;
  white-space: nowrap;
  flex-shrink: 0;
  margin-right: 5px;
  border: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  gap: 5px;
  height: 24px;
}

.recommend-item:last-child {
  margin-right: 0;
}

.manual-service-btn {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #448af7;
  /* border-radius: 20px; */
  padding: 20px 24px;
  /* margin: 10px 0; */
  /* margin-left: -240px; */
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  //background: #fff;
  box-sizing: border-box;

}

.manual-service-btn-disabled {
  color: #999999;
  cursor: not-allowed;
  opacity: 0.7;
}

.manual-service-avatar {
  width: 26.5px;
  height: 26.5px;
  margin-right: 8px;
  border-radius: 50%;
}

.manual-service-text {
  font-size: 11px;
  font-weight: 500;
  color: #ffffff;
  background: rgba(151, 214, 252, 1);
  border-radius: 999px;
  padding: 2.5px 8px;
  display: inline-block;
}

.recommend-icon {
  font-size: 12px;
}

.recommend-item:hover {
  background-color: #e0e0e0;
}

.recommend-item-disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #cccccc;
  border-color: #e0e0e0;
}

.recommend-item-disabled:hover {
  background-color: #cccccc;
}
.chat-main {
  background: url('../../assets/img/chat-background.png') no-repeat center top / cover;
  background-size: 100% 100%;
  width: 100%;
  min-height: calc(100vh - 2.1rem);
  padding-bottom: 10px;
  box-sizing: border-box;
  //min-height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
}

.guideBox {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  word-break: break-all;
  word-wrap: break-word;
  padding: 0;
  position: relative;
  z-index: 10;
  //background: linear-gradient(180deg, #4468BC 0%, #EBECEE 95%);
  border-radius: 20px 20px 0 0;
  box-sizing: border-box;
  margin-bottom: 0;
  height: 156px;
}

.guideBoxContent {
  position: relative;
  word-break: break-all;
  word-wrap: break-word;
  padding: 20px 20px 10px 20px;
  border-radius: 20px 20px 0 0;
  margin-top: 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

.headerRow {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2px;
  position: relative;
}

.headerRow .topBackBtn {
  position: absolute;
  left: 0;
  font-size: 18px;
  position: fixed;
  top: 30px;
  left: 30px;
}

.headerRow .greeting {
  text-align: center;
}

.greeting {
  font-size: 12px;
  font-weight: normal;
  margin: 0;
  text-align: center;
  color: white;
}

.question {
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 10px;
  color: white;
}

.avatarContainer {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  height: 10px;
}

.avatarContainer .headPortrait {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.label-text {
  font-size: 12px;
  font-weight: 400;
  color: rgba(63, 69, 85, 1);
}

.label-text-person{
  width: 50px;
}

.debaoImgBox {
  text-align: center;
}

.debaoImg {
  width: 75px;
  height: 81px;
  vertical-align: middle;
}

.debaoTips {
  font-size: 20px;
  font-weight: 700;
  color: rgba(0, 0, 0, 1);
  padding: 12px 0;
}

.guideLi {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid rgb(201, 196, 196);
  color: #1989fa;
}

ul .guideLi:last-child {
  border-bottom: none;
}

.chat-model {
  display: flex;
  flex-direction: column;
  margin: 2px 2px;
  margin-top: 8px;
}

.chat-model[style*="align-items: flex-end"] {
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
}

.chat-model-person{
  display: flex;
  flex-direction: row;
  padding: 0px 0px 5px 0px;
}

.chat-content-person{
  margin-top: 20px !important;
}
.chat-content {
  position: relative;
  max-width: 69%;
  word-break: break-all;
  word-wrap: break-word;
  /* top: 18px; */
  padding: 10px;
  border-radius: 5px;
}

.chat-content-r {
  background: rgba(255, 255, 255, 1);
  color: rgba(0, 0, 0, 1);
  margin-right: 10px;
  font-size: 14px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 1);
}

.chat-content-l {
  //background-color: #f5f5f5;
  margin-left: 0;
  margin-top: 10px;
  border-radius: 10px;
  padding: 10px 15px;
  //border: 1px solid #e0e0e0;
  width: fit-content;
  max-width: 100%;
  word-break: break-word;
  color: #333333;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 12px;
  box-shadow: 0px 3px 29px 0px rgba(178, 178, 178, 0.35);
}

.chat-content-thinking {
  border: none;
  padding: 0;
  margin-top: 5px;
}

.triangle {
  position: absolute;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-left: 12px solid rgba(255, 255, 255, 1);
  right: -0.5rem;
  top: 12px;
}

.triangleLeft {
  position: absolute;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-right: 10px solid white;
  border-bottom: 10px solid transparent;
  border-left: 10px solid transparent;
  left: -16px;
  top: 8px;
}

.input-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0.3rem 0.4rem 0.3rem;
  margin-top: -0.5rem;
  box-sizing: border-box;
}

.input-wrapper {
  position: relative;
  width: 80%;
  margin-right: 10px;
}

.inputBox {
  width: 295px;
  height: 51px;
  border-radius: 50px;
  border: 1px solid #adacac;
  padding-left: 15px;
  padding-right: 50px;
  box-sizing: border-box;
}

.voice-record-btn {
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.voice-icon-img {
  width: 29px;
  height: 29px;
  vertical-align: middle;
}

.voice-icon {
  width: 29px;
  height: 29px;
  //background-image: url('../../assets/img/voice.png') ;
  //background-size: cover;
  //background-repeat: no-repeat;
  //background-position: center;
  background: url('../../assets/img/voice.png') no-repeat center top / cover;
  background-size: 100% 100%;
}
.voice-message{
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  position: relative;
  overflow: hidden;
}

.sendImgBox {
  width: 43px;
  height: 43px;
  background-color: #ff4d4f;
  border-radius: 50%;
  text-align: center;
  line-height: 40px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sendImg {
  width: 22px;
  height: 21px;
  vertical-align: middle;
  filter: brightness(0) invert(1);
  cursor: pointer;
}

.sendImg-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.sending-icon {
  width: 24px;
  height: 24px;
  border: 2px solid #ffffff;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.pause-icon {
  width: 16px;
  height: 16px;
  background-color: #ffffff;
  border-radius: 2px;
  cursor: pointer;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.mic-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.3s ease;
}

.mic-icon.recording {
  background-color: #ff4d4f;
  animation: pulse 1.5s infinite;
}

.mic-symbol {
  width: 10px;
  height: 14px;
  background-color: #666;
  border-radius: 3px 3px 6px 6px;
  position: relative;
  transition: all 0.3s ease;
}

.mic-icon.recording .mic-symbol {
  background-color: white;
}

.mic-symbol::after {
  content: '';
  position: absolute;
  top: -4px;
  left: 50%;
  transform: translateX(-50%);
  width: 8px;
  height: 8px;
  border: 2px solid #666;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.mic-icon.recording .mic-symbol::after {
  border-color: white;
}

.mic-icon.recording::before {
  content: '';
  position: absolute;
  width: 24px;
  height: 24px;
  border: 2px solid rgba(255, 77, 79, 0.5);
  border-radius: 50%;
  animation: sound-wave 1s infinite ease-out;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes sound-wave {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

.voice-bubble {
  min-width: 80px;
  max-width: 200px;
  padding: 10px 15px;
  display: inline-block;
}

.voice-container {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  min-width: 80px;
  height: 14px;
}

.voice-icon {
  width: 29px;
  height: 29px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  //margin-left: 5px;
  position: relative;
  overflow: hidden;
}

.chat-content-l .voice-icon {
  background-color: rgba(0, 0, 0, 0.1);
}
.voice-message {
  width: 29px;
  height: 29px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.chat-content-l .voice-message {
  background-color: rgba(0, 0, 0, 0.1);
}

.voice-message.playing {
  animation: pulse 1.5s infinite;
}

.voice-message.playing .play-symbol {
  display: none;
}

.voice-message.playing::after {
  content: '';
  position: absolute;
  width: 12px;
  height: 12px;
  border: 2px solid currentColor;
  border-radius: 50%;
  animation: sound-wave 1s infinite ease-out;
}

.voice-message.playing::before {
  content: '';
  position: absolute;
  width: 8px;
  height: 8px;
  border: 2px solid currentColor;
  border-radius: 50%;
  animation: sound-wave 1s infinite ease-out 0.2s;
}

.play-symbol {
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 8px solid #333;
  margin-left: 2px;
}

.voice-icon.playing {
  animation: pulse 1.5s infinite;
}

.voice-icon.playing .play-symbol {
  display: none;
}

.voice-icon.playing::after {
  content: '';
  position: absolute;
  width: 12px;
  height: 12px;
  border: 2px solid currentColor;
  border-radius: 50%;
  animation: sound-wave 1s infinite ease-out;
}

.voice-icon.playing::before {
  content: '';
  position: absolute;
  width: 8px;
  height: 8px;
  border: 2px solid currentColor;
  border-radius: 50%;
  animation: sound-wave 1s infinite ease-out 0.2s;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes sound-wave {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  100% {
    transform: scale(2);
    opacity: 0;
  }
}

.voice-length {
  font-size: 12px;
  color: #000000;
  white-space: nowrap;
}

.chat-content-l .voice-length {
  color: #000000;
  background: #adacac;
}

.recording-status {
  position: fixed;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  z-index: 1000;
}

.recording-dot {
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%;
  margin-right: 8px;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    opacity: 1;
  }

  50% {
    transform: scale(1.2);
    opacity: 0.7;
  }

  100% {
    transform: scale(0.8);
    opacity: 1;
  }
}

.evaluateBox {
  font-size: 12px;
  margin-top: 15px;
  margin-left: 16%;
  max-width: 69%;
  height: 35px;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}

.goodBox {
  display: inline-block;
  width: 20%;
}

.noGoodBox {
  display: inline-block;
  width: 20%;
}

.guideImage {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

.manualService a {
  color: #1e90ff;
  margin-right: 10px;
  position: absolute;
  right: 0;
}

.historyBtnBox {
  //margin: 20px 0;
  position: relative;
}

.showHistory {
  color: dodgerblue;
  text-align: center;
}

.cover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.imgMsg {
  width: 150px;
}

.van-loading {
  display: inline-block;
  text-align: center;
  margin-left: 5px;
  vertical-align: bottom;
}

.separateLineBox {
  display: flex;
  align-items: center;
  margin: 30px auto;
  width: 90%;
  text-align: center;
}

.separateLineBox::before,
.separateLineBox::after {
  content: '';
  flex: 1;
  border-top: 0.5px dashed #c1bfbf;
}

.historyText {
  font-size: 11px;
  padding: 0 10px;
  text-align: center;
  color: #adacac;
  background: transparent;
  margin: 0;
}

.watchDetail {
  color: #448af7;
  font-size: 14px;
}

.talkMsg {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  font-size: 14px;
}

.fileBox {
  width: 150px;
  height: 40px;
  display: flex;
}

.fileIcon {
  width: 34px;
  margin-left: auto;
}

.fileSize {
  color: #adacac;
  font-size: 12px;
}

.headPortrait {
  width: 26.5px;
  height: 26.5px;
}

.headPortrait-person{
  width: 39px;
  height: 38.5px;
}
.headPortrait-chat{
  width: 34.5px;
  height: 34px;
}
.backBtn {
  width: 28px;
  height: 28px;
  vertical-align: middle;
}

.call {
  color: #1e90ff;
}

.phone {
  width: 22px;
  vertical-align: middle;
}

.evaluate-text-row {
  display: inline;
}

.evaluateButton {
  color: #1e90ff;
  display: inline;
}

.evaluate-btn-inner {
  display: inline-flex;
  align-items: center;
  background-color: #97D6FC;
  color: #ffffff;
  padding: 2px 8px;
  border-radius: 15px;
  font-size: 10px;
  cursor: pointer;
  margin-left: 0px;
}

.evaluate {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  margin-right: 4px;
  margin-left: 0px;
  filter: brightness(0) invert(1);
}

.van-rate {
  width: 80%;
  display: flex;
  justify-content: space-around;
  margin: 0 auto;
}

.evaluateMain {
  padding: 20px;
  padding-top: 0px;
}

/deep/ .evaluateMain .van-field__label {
  margin-right: 0;
}

.evaluateContent {
  text-align: center;
  color: red;
  font-size: 16px;
  font-weight: bold;
  margin-top: 15px;
}

.submitEvaluate {
  width: 100%;
  font-size: 14px;
  margin-top: 10px;
  background-color: #ff4444 !important;
  border-radius: 22px !important;
  border: none !important;
  height: 36px !important;
  box-shadow: 0 4px 12px rgba(255, 68, 68, 0.4) !important;
}

.currentLi {
  color: red;
  font-weight: 600;
}

.van-popup--right.van-popup--round {
  border-radius: 10px 0 0 10px;
}

.richText {
  white-space: pre-wrap;
}

.personLine {
  color: #adacac;
  text-align: center;
  font-size: 14px;
}

.manualService {
  color: #448af7;
}

.queueUp {
  text-align: center;
  margin: 20px 0;
  padding: 0 10px;
}
/* 思考中 无边框 */
.chat-content-thinking {
  padding: 10px 15px;
  color: #666;
  font-size: 14px;
  background: transparent;
  border: none;
  margin-left: 0;
}
.withdrawMsgBox {
  text-align: center;
  margin: 20px 0;
  font-size: 12px;
  color: #a9a5a5;
}

.slogan {
  position: relative;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  text-align: center;
  border-bottom: 1px solid #dbdbdb;
  padding: 0 20px;
}

.topBackBtn {
  position: absolute;
  left: 5px;
  font-size: 18px;
  z-index: 10;
}

.backArrow {
  width: 22px;
  height: 11px;
  vertical-align: middle;
}

.sloganImg {
  width: 28px;
  vertical-align: middle;
  margin-right: 5px;
}

.topBackBtn {
  font-size: 18px;
  position: absolute;
  left: 5px;
}

.testQueryBtn {
  background-color: rgba(0, 122, 255, 1);
  border: 0.02667rem solid rgba(0, 122, 255, 1);
  border-radius: 8px;
  margin-top: 20px;
}
/* 反馈弹窗标题居左 */
.evaluate-action-sheet /deep/ .van-action-sheet__header {
  text-align: left;
  padding-left: 18px;
}

/* 反馈弹窗样式 */
.evaluate-action-sheet {
  /deep/ .van-action-sheet__content {
    padding: 8px 10px;
  }

  .evaluate-textarea-wrapper {
    background-color: #DFDFDF  !important;
    border-radius: 10px;
    margin-bottom: 16px;
    padding: 2px;
  }

  /deep/ .evaluate-textarea {
    background-color: #DFDFDF !important;
    padding: 0;
  }

  /deep/ .van-cell {
    background-color: #DFDFDF !important;
    padding: 0;
  }

  /deep/ .van-field__body {
    background-color: #DFDFDF !important;
  }

  /deep/ .van-field__control {
    color: #333;
    font-size: 10px;
    line-height: 1.6;
    background-color: #DFDFDF !important;
  }

  /deep/ .van-field__word-limit {
    color: #999;
    font-size: 12px;
    margin-top: 2px;
    background-color: #DFDFDF !important;
  }

  /* 标签样式 */
  .evaluate-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 20px;

    .tag-item {
      padding: 2px 10px;
      border-radius: 16px;
      font-size: 10px;
      color: #666;
      background-color: #f0f0f0;
      cursor: pointer;
      transition: all 0.3s;

      &.active {
        background-color: #97D6FC;
        color: #fff;
      }
    }
  }

  /deep/ .submitEvaluate {
    width: 100%;
    height: 44px;
    background-color: #ff4444;
    border: none;
    border-radius: 22px;
    font-size: 16px;
    color: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/chat/chatDetail.vue